export const WorkingHoursSection = {
  countries: [
    {
      country: "South Africa",
      section: "Working Hours",
      details: {
        working_hours: {
          general: "The standard working week in South Africa can be no longer than 45 hours a week, 9 hours per day.",
        },
        overtime: {
          description: "If work time limits are passed, overtime pay is compulsory. The maximum overtime hours are up to 10 hours per working week.",
          overtime_rate: {
            weekday: "150.00%",
            weekend: "200.00%",
          },
          thresholds: {
            overtime_eligibility: {
              below_threshold: "Employees earning below 205,433.30 ZAR annually are entitled to overtime pay.",
              above_threshold: "Employees earning over 254,371.67 ZAR annually are not entitled to any overtime compensation.",
            },
          },
          contract: "It is not possible in the employment contract to have a salary which already includes overtime pay.",
        },
      },
    },
    {
      country: "India",
      section: "Working Hours",
      details: {
        working_hours: {
          general: "The standard working hours in India are 9 hours per day and 48 hours per week, as per the Factories Act, 1948.",
        },
        overtime: {
          description: "Overtime must be compensated for work beyond 9 hours per day or 48 hours per week.",
          overtime_rate: {
            weekday: "200.00%",
            weekend: "200.00%",
          },
          thresholds: {
            overtime_eligibility: {
              below_threshold: "Workers classified as 'workmen' under labor laws are entitled to overtime pay.",
              above_threshold: "Employees in managerial or supervisory roles may not be eligible for overtime compensation.",
            },
          },
          contract: "Employment contracts cannot include a salary that inherently covers overtime unless explicitly agreed upon under labor laws.",
        },
      },
    },
    {
      country: "United States",
      section: "Working Hours",
      details: {
        working_hours: {
          general: "The standard workweek in the United States is 40 hours, 8 hours per day.",
        },
        overtime: {
          description: "Overtime is required for work exceeding 40 hours per week.",
          overtime_rate: {
            weekday: "150.00%",
            weekend: "Not commonly applicable.",
          },
          thresholds: {
            overtime_eligibility: {
              below_threshold: "Non-exempt employees are entitled to overtime pay.",
              above_threshold: "Exempt employees are not entitled to overtime compensation.",
            },
          },
          contract: "Exempt employees' salaries may include a provision for additional work hours without overtime pay.",
        },
      },
    },
    {
      country: "Germany",
      section: "Working Hours",
      details: {
        working_hours: {
          general: "The standard workweek in Germany is 40 hours, typically 8 hours per day with a legal maximum of 48 hours.",
        },
        overtime: {
          description: "Overtime rules are typically determined by collective bargaining agreements.",
          overtime_rate: {
            weekday: "Not standardized, varies by sector.",
            weekend: "Typically higher rates, varies by sector.",
          },
          thresholds: {
            overtime_eligibility: {
              below_threshold: "Eligibility depends on collective agreements.",
              above_threshold: "Typically, higher-salaried employees are not entitled to overtime pay.",
            },
          },
          contract: "Collective agreements or contracts may specify if overtime is compensated or accounted for with time off.",
        },
      },
    },
    // Add more countries as needed
  ],
};
